<template>
  <div class="app-wrapper-footer">
    <div class="app-footer">
      <div class="app-footer__inner">
        <div class="app-footer-left">
          <ul class="nav">
            <li class="nav-item">
              <a href="javascript:void(0);" class="nav-link">
                &copy; 2020 Infostrategy Technology
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "FooterBottom"
};
</script>
<style scoped>
@media screen and (max-width: 600px) {
  .app-wrapper-footer {
    position: absolute;
    top: calc(100% - 60px);
    width: 100%;
  }
}
</style>
